<button
  type="button"
  ngpSwitch
  ngpFocus
  [id]="effectiveId"
  [ngpSwitchChecked]="isChecked"
  [ngpSwitchDisabled]="isDisabled()"
  [attr.aria-invalid]="errorState ? 'true' : null"
  (ngpSwitchCheckedChange)="onCheckedChange($event)"
  (blur)="markTouched()"
>
  <span class="track" aria-hidden="true">
    <span ngpSwitchThumb class="thumb"></span>
  </span>
  <!-- Optional label beside the track (like sui-checkbox). Renders nothing —
       and adds no flex gap — when no content is projected. -->
  <ng-content />
</button>
